
import { RootState } from "../../../index";

export const LiveChatData = (state: RootState) => state.chat.data;
export const LiveChatAiEditorData = (state: RootState) => state.chat.data.aiEditorChatData;
export const LiveChatAiEditorLoading = (state: RootState) => state.chat.loading;
export const LiveChatAiEditorError = (state: RootState) => state.chat.error;